import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Breadcrumbs from '~/components/blog/breadcrumbs';
import { Trans } from '@lingui/react';
import { getBlogDetailImage } from '~/components/blog/blogImages';

function BlogItemDetail ({ article, country }) {
    const [pathname, setPathname] = useState('');

    useEffect(() => {
        setPathname(window.location);
    });

    return (
        <>
            <BlogItemDetailContainer>
                <Breadcrumbs title={article.title} country={country} />

                <Header>
                    <Left>
                        <Title>{article.title}</Title>
                        <Perex dangerouslySetInnerHTML={{ __html: article.perex }} />
                    </Left>
                    <Right>
                        <Thumbnail
                            src={getBlogDetailImage(article.image.src)}
                            alt={article.title}
                        />
                        <ShareWrapper>
                            <Trans id="blog.shareArticle" />
                            <IconsWrapper>
                                <ShareLinkTwitter
                                    href={`https://twitter.com/intent/tweet?url=${pathname}`}
                                    target="_blank"
                                >
                                    <img
                                        src="/static/images/socials/blog/twitter.svg"
                                        alt="Our twittwe"
                                    />
                                </ShareLinkTwitter>
                                <ShareLinkFacebook
                                    href={`https://www.facebook.com/sharer/sharer.php?u=${pathname}`}
                                    target="_blank"
                                >
                                    <img
                                        src="/static/images/socials/blog/facebook.svg"
                                        alt="Our instagram"
                                    />
                                </ShareLinkFacebook>
                                <ShareLinkLinkedin
                                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${pathname}`}
                                    target="_blank"
                                >
                                    <img
                                        src="/static/images/socials/blog/linkedin.svg"
                                        alt="Our instagram"
                                    />
                                </ShareLinkLinkedin>
                            </IconsWrapper>
                        </ShareWrapper>
                    </Right>
                </Header>

                {/* Converts string (article content) generated by React admin => html/JSX */}
                <Text dangerouslySetInnerHTML={{ __html: article.content }} />

            </BlogItemDetailContainer>
        </>
    );
}

export default BlogItemDetail;

const BlogItemDetailContainer = styled.div`
    margin: 0 auto;
    max-width: 954px;
    padding: 2rem 1rem;
    overflow-wrap: break-word;
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;

    @media (max-width: 840px) {
        justify-content: center;
        flex-wrap: wrap-reverse;
    }
`;

const Left = styled.div`
    @media (min-width: 840px) {
        max-width: 460px;
    }
`;

const Right = styled.div``;

const Title = styled.h1`
    font-weight: bold;
    font-size: 32px;
    line-height: 48px;
    letter-spacing: 0.02em;
    color: #000000;

    @media (max-width: 840px) {
        font-size: 42px;
    }

    @media (max-width: 540px) {
        font-size: 34px;
    }
`;

const Perex = styled.p`
    margin-top: 1.8rem;
    line-height: 1.7;
    font-size: 18px;

    strong {
        font-weight: bold;
    }
`;

const Thumbnail = styled.img`
    width: 100%;
    height: auto;
    padding-left: 2rem;
    max-width: 460px;

    @media (max-width: 840px) {
        padding-left: 0;
        padding-bottom: 2rem;
    }
`;

const ShareWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: 2rem;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 25px;
    /* identical to box height, or 208% */
    letter-spacing: 0.4px;
    color: #2f2f2f;
    margin-top: 16px;

    @media (max-width: 840px) {
        padding-left: 0;
        padding-bottom: 2rem;
    }
`;
const IconsWrapper = styled.div`
    margin-top: 8px;
    display: flex;
`;

const ShareLink = styled.a`
    margin-right: 11px;
    cursor: pointer;
`;

const ShareLinkFacebook = styled(ShareLink)`
    &:hover img {
        content: url('/static/images/socials/blog/facebook_hov.svg');
    }
    /* Image Preloader */
    &:before {
        visibility: hidden;
        background: url('/static/images/socials/blog/facebook_hov.svg');
        content: '';
    }
`;

const ShareLinkLinkedin = styled(ShareLink)`
    &:hover img {
        content: url('/static/images/socials/blog/linkedin_hov.svg');
    }

    /* Image Preloader */
    &:before {
        visibility: hidden;
        background: url('/static/images/socials/blog/linkedin_hov.svg');
        content: '';
    }
`;

const ShareLinkTwitter = styled(ShareLink)`
    &:hover img {
        content: url('/static/images/socials/blog/twitter_hov.svg');
    }

    /* Image Preloader */
    &:before {
        visibility: hidden;
        background: url('/static/images/socials/blog/twitter_hov.svg');
        content: '';
    }
`;

const Text = styled.div`
    padding-bottom: 150px;
    color: black;
    line-height: 1.7;
    font-size: 18px;
    font-weight: 300;

    h2 {
        font-size: 32px;
        letter-spacing: 1.09px;
        margin: 2rem 0 1rem 0;
        font-weight: 300;

        @media (max-width: 840px) {
            font-size: 26px;
        }

        @media (max-width: 540px) {
            font-size: 24px;
        }
    }

    h3 {
        font-size: 24px;
        letter-spacing: 0.82px;
        margin: 2rem 0 1rem 0;
        font-weight: 300;

        @media (max-width: 840px) {
            font-size: 22px;
        }
    }

    h4 {
        font-size: 20px;
        letter-spacing: 0.82px;
        margin-bottom: 0.7rem;
        font-weight: 300;
    }

    h5 {
        font-size: 18px;
        letter-spacing: 0.82px;
        margin-bottom: 0.5rem;
        font-weight: 300;
    }

    h6 {
        font-size: 16px;
        letter-spacing: 0.82px;
        margin-bottom: 0.5rem;
        font-weight: 300;
    }

    p {
        margin-bottom: 1rem;
        font-size: 18px;
    }

    strong {
        font-weight: bold;
    }

    ol,
    dl,
    ul {
        margin-bottom: 2rem;
    }

    a {
        color: #009b77 !important;
    }

    img {
        max-width: 100%;
        height: auto;
    }

`;
